function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M277.6,135.8l-44.7-36.4c-3.5-3.5-9.5-1-9.5,4v22.4h-69.8V55.9H176c4.9,0,7.4-6,4-9.5L143.6,1.6 c-2.2-2.2-5.7-2.2-7.9,0L99.4,46.3c-3.5,3.5-1,9.5,4,9.5h22.4v69.8H55.9v-22.4c0-4.9-6-7.4-9.5-4L1.6,135.6c-2.2,2.2-2.2,5.7,0,7.9 l44.7,36.4c3.5,3.5,9.5,1,9.5-4v-22.4h69.8v69.8h-22.4c-4.9,0-7.4,6-4,9.5l36.2,44.7c2.2,2.2,5.7,2.2,7.9,0l36.4-44.7 c3.5-3.5,1-9.5-4-9.5h-22.4v-69.8h69.8v22.4c0,4.9,6,7.4,9.5,4l44.7-36.2C279.8,141.4,279.8,137.9,277.6,135.8z"
});

var SvgDragIcon = function SvgDragIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "279.2px",
    height: "279.2px",
    viewBox: "0 0 279.2 279.2",
    style: {
      enableBackground: "new 0 0 279.2 279.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDragIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dragIcon.4f35962c.svg";
export { ForwardRef as ReactComponent };